import { render } from "./serviceAllocate.vue?vue&type=template&id=2da9ef74&scoped=true"
import script from "./serviceAllocate.vue?vue&type=script&lang=js"
export * from "./serviceAllocate.vue?vue&type=script&lang=js"

import "./serviceAllocate.vue?vue&type=style&index=0&id=2da9ef74&lang=less&scoped=true"

import exportComponent from "/Users/yiduolanghua/Desktop/edu/visitor-h5-jy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da9ef74"]])

export default __exports__